/**
 * Configuration resolved at container start rather than at build time.
 *
 * Vite inlines `import.meta.env.*` into the bundle, which would pin one image to
 * one environment — the opposite of what a registry-published image is for. The
 * CMS container instead writes `/config.js` from its environment before nginx
 * serves anything, and cms.html loads it ahead of the app.
 *
 * Build-time values remain the fallback, so `pnpm dev` and the platform bundle
 * keep working unchanged.
 */
declare global {
  interface Window {
    __KIBO_CONFIG__?: Record<string, string>;
  }
}

function runtime(key: string): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const value = window.__KIBO_CONFIG__?.[key];
  // The generated file leaves unset variables as the empty string, and the
  // placeholder survives if substitution never ran — treat both as absent so
  // the build-time fallback wins instead of a broken URL reaching Keycloak.
  if (!value || value.startsWith('__')) return undefined;
  return value;
}

/** Runtime value if the container supplied one, else the build-time default. */
export function config(key: string, buildTime: string | undefined, fallback = ''): string {
  return runtime(key) ?? (buildTime ?? '').trim() ?? fallback;
}
